import { render, staticRenderFns } from "./slider-drawer.vue?vue&type=template&id=57f0d3f2&"
import script from "./slider-drawer.vue?vue&type=script&lang=js&"
export * from "./slider-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports